var base = require('settings/profile/exchange-setting');

Vue.component('spark-exchange-setting', {
    mixins: [base],

    data() {
        return {
            form: $.extend(true, new SparkForm({
                exchange_email                 : '',
                exchange_username                : '',
                exchange_password                : '',
                exchange_server_address                : '',
            }), Spark.forms.exchangeSettings)
        };
    },

    created() {

    },

    methods: {
    }
});
